import React, {Component} from 'react';
import BarTitle from "../../../components/BarTitle/index";
import Painel from "../../../components/Painel/index";
import constants from '../../../constants';
import axios from 'axios';

class DecryptCardView extends Component {
    constructor(props) {
        super(props);
        this.handleChange = this.handleChange.bind(this);
        this.state = {result: ''};
    }

    handleChange(event) {
        event.preventDefault();
        let value = event.target.value;

        const decryptUrl = constants().URL_SERVICE + 'creditcard';

        axios.post(decryptUrl, {
                value
            }, {headers: {'token': localStorage.token}}
        ).then((response) => {
            if (response.data) {
                this.setState({result: response.data})
            } else {
                this.setState({result: '<h4>Chave inválida</h4>'})
            }
        })//.catch(error => this.setState({error: true}));

    };

    render() {
        return (
            <div>
                <BarTitle name="Descriptografar Cartão"/>
                <div className="wrapper-md">
                    <form>
                        <Painel title="Insira o código criptógrafo.">
                            <textarea onChange={this.handleChange} className="form-control" rows="3"></textarea>
                        </Painel>
                        <span dangerouslySetInnerHTML={{__html: this.state.result}}/>
                    </form>
                </div>
            </div>
        );
    }
}

export default DecryptCardView;



// WEBPACK FOOTER //
// ./src/views/Util/DecryptCard/index.js